import { EN_LANGUAGE, DE_REGION, NL_REGION, FR_REGION, GB_REGION, REGION_ALIASES, FR_FR_LOCALE, EN_FR_LOCALE, EN_DE_LOCALE, DE_DE_LOCALE, EN_NL_LOCALE, NL_NL_LOCALE, EN_GB_LOCALE, EN_US_LOCALE, ES_US_LOCALE } from '@lemonade-hq/lemonation';

/* eslint-disable @typescript-eslint/naming-convention */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
var ALL_ROUTES = (_obj = {
    default: {
        home: "",
        bundles: "bundles",
        faq: "faq",
        claims: "claims",
        giveback: "giveback",
        giveback_2019: "giveback-2019",
        giveback_2020: "giveback-2020",
        giveback_2021: "giveback-2021",
        giveback_2022: "giveback-2022",
        giveback_2023: "giveback-2023",
        reviews: "reviews",
        insurance_solved: "insurance-solved",
        privacy_policy: "privacy-policy",
        blog: "blog/",
        api: "api",
        terms_of_service: "terms-of-service",
        telematics_terms_of_service: "telematics-terms-and-conditions",
        global_expansion: "lemonade-goes-global",
        partners_program: "partners-program",
        legal_stuff: "legal-stuff",
        accessibility: "accessibility",
        homeowners: "homeowners",
        renters: "renters",
        policy_two: "policy-two",
        transparency: "transparency",
        insuropedia: "insuropedia/",
        investors: "investors",
        makers: "makers",
        login: "login",
        pet: "pet",
        pet_insurance: "pet-insurance",
        pet_customizable_insurance: "pet/customizable-insurance",
        vets: "vets",
        life: "life",
        car: "car",
        term_life: "life",
        covid_19: "blog/covid-19",
        vets_education: "vets-education",
        vets_giveaway: "the-story-of-your-pet",
        leasing_managers_program: "leasing-managers-program",
        consumers_advocate: "consumers-advocate",
        renters_insurance: "renters-insurance",
        thank_you: "thank-you",
        car_explained: "car/explained/",
        pet_explained: "pet/explained/",
        life_explained: "life/explained/",
        renters_explained: "renters/explained/",
        home_explained: "homeowners/explained/",
        manage_cookies: "",
        do_not_share_my_personal_information: "",
        renters_hub: "",
        personal_liability_hub: "",
        expats_de: "",
        expats_nl: "",
        pet_dog_insurance_explained: "pet/dogs",
        pet_cat_insurance_explained: "pet/cats",
        car_insurance_by_vehicle: "car/vehicles/",
        contents: "contents",
        gravity: "gravity",
        pet_compare: "pet/compare",
        sitemap: "sitemap",
        terms_and_conditions_referral_program: "terms-and-conditions-referral-program",
        what_is_renters_insurance: "renters/explained/what-is-renters-insurance/",
        renters_insurance_coverage: "renters/explained/what-is-renters-insurance-and-whats-covered/",
        renters_insurance_cost: "renters/explained/this-is-how-much-renters-insurance-actually-costs/",
        how_to_get_renters_insurance: "renters/explained/getting-renters-insurance/",
        car_and_renters_bundle: "renters/explained/renters-and-car-insurance-bundle/",
        car_insurance: "car",
        pay_per_mile_car_insurance: "car/explained/pay-per-mile-car-insurance/",
        car_insurance_coverage: "car/explained/what-does-car-insurance-cover/",
        car_insurance_cost: "car/explained/how-much-does-car-insurance-cost/",
        comprehensive_car_insurance: "car/explained/comprehensive-coverage/",
        dog_insurance: "pet/dogs",
        cat_insurance: "pet/cats",
        compare_pet_insurance: "pet/compare",
        pet_insurance_coverage: "pet/explained/pet-insurance/",
        pet_insurance_cost: "pet/explained/pet-insurance-cost/",
        investor_relations: "home/default.aspx",
        homeowners_insurance: "homeowners",
        what_is_homeowners_insurance: "homeowners/explained/what-is-homeowners-insurance/",
        homeowners_insurance_coverage: "homeowners/explained/what-homeowners-insurance-covers/",
        homeowners_insurance_cost: "homeowners/explained/homeowners-insurance-cost/",
        how_much_home_insurance_do_i_need: "homeowners/explained/how-much-homeowners-insurance-do-i-need/",
        car_and_home_bundle: "homeowners/explained/homeowners-and-car-insurance-bundle/",
        term_life_insurance: "life",
        life_insurance_coverage: "life/explained/what-does-life-insurance-cover/",
        no_exam_life_insurance: "life/explained/no-exam-life-insurance/",
        how_does_life_insurance_work: "life/explained/irrevocable-beneficiary/",
        how_much_life_insurance_do_i_need: "life/explained/how-much-life-insurance-do-i-need/",
        contingent_beneficiary: "life/explained/contingent-beneficiary/",
        term_life_insurance_main_page: "life",
        homeowners_insurance_main_page: "homeowners",
        pet_insurance_main_page: "pet",
        car_insurance_main_page: "car",
        renters_insurance_main_page: "renters",
        explaining_renters: "renters/explained/",
        explaining_homeowners: "homeowners/explained/",
        explaining_pet: "pet/explained/",
        explaining_car: "car/explained/",
        explaining_life: "life/explained/",
        complaints: "faq#how-to-submit-a-complaint",
        global_transparency: "",
        global_reviews: "",
        global_api: "",
        blog_en_de_liability_insurance_germany: "",
        blog_en_de_deductible: "",
        blog_en_de_insurances_in_germany: "",
        blog_en_de_laptop_insurance_germany: "",
        blog_en_de_camera_insurance: "",
        blog_en_nl_content_insurance: "",
        blog_en_nl_liability_insurance: "",
        global_partners_program: "",
        insuropedia_nl: "",
        global_blog_fr: "",
        global_blog_uk: "",
        global_blog_nl: "",
        global_blog_de: ""
    }
}, _define_property(_obj, DE_REGION, _define_property({
    default: {
        home: "",
        faq: "faq",
        claims: "schadensabwicklung",
        giveback: "giveback",
        giveback_2021: "giveback-2021",
        giveback_2022: "giveback-2022",
        giveback_2023: "giveback-2023",
        policy_two: "police-zwei",
        privacy_policy: "datenschutzinformation",
        impressum: "impressum",
        terms_of_service: "nutzungsbedingungen",
        global_expansion: "lemonade-goes-global",
        legal_stuff: "rechtliches",
        blog: "blog/",
        insuropedia: "versicherungslexikon/",
        login: "login",
        accessibility: "barrierefreiheit",
        manage_cookies: "",
        personal_liability_hub: "privathaftpflicht/einfach-erklaert/",
        renters_hub: "hausrat/einfach-erklaert/",
        sitemap: "sitemap",
        content_insurance_hub: "hausrat/einfach-erklaert/hausratversicherung/",
        costs_home_contents_insurance_hub: "hausrat/einfach-erklaert/kosten-hausratversicherung/",
        homeowners_insurance_hub: "hausrat/einfach-erklaert/wohngebaeudeversicherung/",
        external_insurance_hub: "hausrat/einfach-erklaert/aussenversicherung/",
        insurance_as_tenant: "privathaftpflicht/einfach-erklaert/welche-versicherungen-als-mieter/",
        insurance_policies_hub: "privathaftpflicht/einfach-erklaert/welche-versicherungen-braucht-man",
        multiple_insurance_hub: "privathaftpflicht/einfach-erklaert/mehrfachversicherung/",
        facts_insurance_hub: "privathaftpflicht/einfach-erklaert/schluesselversicherung/",
        global_blog_de: "global_blog_de"
    }
}, EN_LANGUAGE, {
    claims: "claims",
    giveback: "giveback",
    giveback_2021: "giveback-2021",
    giveback_2022: "giveback-2022",
    giveback_2023: "giveback-2023",
    policy_two: "policy-two",
    privacy_policy: "privacy-policy",
    accessibility: "accessibility",
    imprint: "imprint",
    terms_of_service: "terms-of-service",
    global_expansion: "lemonade-goes-global",
    insuropedia: "insuropedia/",
    legal_stuff: "legal-stuff",
    manage_cookies: "",
    expats_de: "expats_de",
    global_transparency: "global_transparency",
    global_reviews: "global_reviews",
    blog_en_de_liability_insurance_germany: "blog_en_de_liability_insurance_germany",
    blog_en_de_deductible: "blog_en_de_deductible",
    blog_en_de_insurances_in_germany: "blog_en_de_insurances_in_germany",
    blog_en_de_laptop_insurance_germany: "blog_en_de_laptop_insurance_germany",
    blog_en_de_camera_insurance: "blog_en_de_camera_insurance"
})), _define_property(_obj, NL_REGION, _define_property({
    default: {
        home: "",
        claims: "claims",
        giveback: "giveback",
        giveback_2021: "giveback-2021",
        giveback_2022: "giveback-2022",
        giveback_2023: "giveback-2023",
        global_expansion: "lemonade-gaat-global",
        privacy_policy: "privacybeleid",
        terms_of_service: "algemene-voorwaarden",
        imprint: "colofon",
        policy_two: "polis-twee",
        faq: "faq",
        legal_stuff: "de-kleine-lettertjes",
        makers: "makers",
        blog: "blog/",
        insuropedia: "verzekeringstermen/",
        accessibility: "toegankelijkheid",
        login: "login",
        insurance_card: "faq#insurance-card",
        manage_cookies: "",
        personal_liability_hub: "aansprakelijkheid/uitgelegd/",
        renters_hub: "inboedel/uitgelegd/",
        sitemap: "sitemap",
        terms_and_conditions_referral_program: "aanbevelingsprogramma-algemene-voorwaarden",
        insuropedia_nl: "insuropedia_nl",
        liability_insurance_hub: "aansprakelijkheid/uitgelegd/aansprakelijkheidsverzekering/",
        third_party_liability_insurance_hub: "aansprakelijkheid/uitgelegd/wa-verzekering/",
        private_liability_insurance_hub: "aansprakelijkheid/uitgelegd/aansprakelijkheidsverzekering-faqs/",
        home_content_insurance_hub: "inboedel/uitgelegd/inboedelverzekering/",
        cost_content_insurance_hub: "inboedel/uitgelegd/inboedelverzekering-kosten/",
        bicycle_insurance_hub: "inboedel/uitgelegd/fietsverzekeringen/",
        insuring_e_bike_hub: "inboedel/uitgelegd/e-bike-verzekeren/",
        phone_insurance_hub: "inboedel/uitgelegd/telefoon-verzekeren/",
        global_blog_nl: "global_blog_nl",
        what_is_building_insurance: "opstalverzekering/uitgelegd/wat-is-een-opstalverzekering/",
        how_much_does_home_insurance_cost: "opstalverzekering/uitgelegd/opstalverzekering-kosten/",
        differences_between_content_and_building_insurance: "opstalverzekering/uitgelegd/inboedel-en-opstalverzekering-wat-is-het-verschil/",
        mandatory_building_insurance: "opstalverzekering/uitgelegd/is-een-opstalverzekering-verplicht/",
        woz_value: "opstalverzekering/uitgelegd/wat-is-woz-waarde/",
        apartment_building_insurance: "opstalverzekering/uitgelegd/opstalverzekering-appartement/"
    }
}, EN_LANGUAGE, {
    claims: "claims",
    giveback: "giveback",
    giveback_2021: "giveback-2021",
    giveback_2022: "giveback-2022",
    giveback_2023: "giveback-2023",
    global_expansion: "lemonade-goes-global",
    privacy_policy: "privacy-policy",
    insuropedia: "insuropedia/",
    terms_of_service: "terms-of-service",
    imprint: "imprint",
    policy_two: "policy-two",
    accessibility: "accessibility",
    faq: "faq",
    legal_stuff: "legal-stuff",
    manage_cookies: "",
    expats_nl: "expats_nl",
    terms_and_conditions_referral_program: "terms-and-conditions-referral-program",
    blog_en_nl_content_insurance: "blog_en_nl_content_insurance",
    blog_en_nl_liability_insurance: "blog_en_nl_liability_insurance",
    global_partners_program: "global_partners_program",
    investors: "investors",
    global_reviews: "global_reviews"
})), _define_property(_obj, FR_REGION, _define_property({
    default: {
        home: "",
        renters: "assurance-habitation-locataire",
        homeowners: "assurance-habitation",
        claims: "remboursement-sinistres",
        cardif: "cardif",
        accessibility: "accessibilite",
        giveback: "giveback",
        giveback_2021: "giveback-2021",
        giveback_2022: "giveback-2022",
        giveback_2023: "giveback-2023",
        global_expansion: "presence-internationale",
        privacy_policy: "confidentialite",
        terms_of_service: "conditions-generales",
        policy_two: "police-2",
        faq: "faq",
        blog: "blog/",
        insuropedia: "dictionnaire-assurance/",
        legal_stuff: "mentions-legales",
        makers: "makers",
        login: "login",
        manage_cookies: "",
        renters_hub: "habitation/conseils/",
        sitemap: "sitemap",
        terms_and_conditions_referral_program: "conditions-generales-parrainage",
        complaints: "faq#quelles-sont-les-modalit\xe9s-de-r\xe9clamation-",
        assurance_habitation_locataire: "assurance-habitation-locataire",
        guide_assurance_locataires: "habitation/conseils/guide-assurance-habitation-locataires/",
        assurance_responsabilité_civile: "habitation/conseils/tout-savoir-sur-lassurance-responsabilite-civile/",
        assurance_habitation_pour_é_tudiants: "habitation/conseils/assurance-habitation-etudiant/",
        prix_d_une_assurance_habitation: "habitation/conseils/prix-assurance-habitation/",
        assurance_scolaire: "habitation/conseils/assurance-scolaire/",
        attestation_d_assurance_habitation: "habitation/conseils/attestation-assurance-habitation/",
        assurance_téléphone: "habitation/conseils/assurance-telephone/",
        paiement_assurance_habitation: "habitation/conseils/guide-des-paiements/",
        assurance_habitation: "assurance-habitation",
        en_quoi_notre_assurance_est_différente: "habitation/conseils/lemonade-assurance-habitation-proprietaire-unique/",
        propriétaires_occupants: "habitation/conseils/guide-assurance-habitation-proprietaires-occupants/",
        propriétaires_non_occupants: "habitation/conseils/guide-assurance-proprietaire-non-occupants-pno/",
        locations_saisonnières: "habitation/conseils/locations-saisonnieres/",
        global_blog_fr: "global_blog_fr"
    }
}, EN_LANGUAGE, {
    renters: "renters-insurance",
    homeowners: "home-insurance",
    claims: "claims",
    accessibility: "accessibility",
    cardif: "cardif",
    giveback: "giveback",
    giveback_2021: "giveback-2021",
    giveback_2022: "giveback-2022",
    giveback_2023: "giveback-2023",
    global_expansion: "lemonade-goes-global",
    privacy_policy: "privacy-policy",
    terms_of_service: "terms-of-service",
    policy_two: "policy-two",
    insuropedia: "insuropedia/",
    legal_stuff: "legal-stuff",
    manage_cookies: "",
    terms_and_conditions_referral_program: "terms-and-conditions-referral-program",
    complaints: "faq#how-to-submit-a-complaint",
    renters_insurance_main_page: "renters",
    homeowners_insurance_main_page: "homeowners",
    api: "api",
    partners_program: "partners-program",
    investors: "investors",
    transparency: "transparency",
    reviews: "reviews",
    global_transparency: "global_transparency",
    global_reviews: "global_reviews",
    global_blog_fr: "global_blog_fr"
})), _define_property(_obj, GB_REGION, {
    default: {
        home: "",
        global_api: "global_api",
        claims: "claims",
        accessibility: "accessibility",
        tips: "home-insurance/explained/",
        giveback: "giveback",
        giveback_2021: "giveback-2021",
        giveback_2022: "giveback-2022",
        giveback_2023: "giveback-2023",
        global_expansion: "lemonade-goes-global",
        privacy_policy: "privacy-policy",
        terms_of_service: "terms-of-service",
        policy_two: "policy-two",
        faq: "faq",
        blog: "blog/",
        insuropedia: "insuropedia/",
        legal_stuff: "legal-stuff",
        makers: "makers",
        contents: "contents",
        gravity: "gravity",
        login: "login",
        manage_cookies: "",
        sitemap: "sitemap",
        brand: "brand",
        terms_and_conditions_referral_program: "terms-and-conditions-referral-program",
        global_partners_program: "global_partners_program",
        investors: "investors",
        global_transparency: "global_transparency",
        global_reviews: "global_reviews",
        home_insurance_hub: "home-insurance/explained/",
        home_insurance_coverage_hub: "home-insurance/explained/what-does-home-insurance-cover/",
        home_emergency_cover: "home-insurance/explained/home-emergency-cover/",
        flood_insurance: "home-insurance/explained/flood-insurance/",
        content_insurance_hub: "home-insurance/explained/what-is-contents-insurance/",
        content_insurance_cost_hub: "home-insurance/explained/how-much-does-contents-insurance-cost/",
        content_insurance_coverage_hub: "home-insurance/explained/how-much-contents-insurance-do-i-need/",
        personal_liability_hub: "home-insurance/explained/the-lowdown-on-personal-liability-cover/",
        insurance_valuables_items_hub: "home-insurance/explained/high-value-item-cover/",
        bike_insurance_hub: "home-insurance/explained/bicycle-insurance-explained/",
        phone_insurance_hub: "home-insurance/explained/mobile-phone-insurance-heres-what-you-need-to-know/",
        building_insurance_hub: "home-insurance/explained/what-is-buildings-insurance/",
        building_insurance_coverage_hub: "home-insurance/explained/what-does-building-insurance-cover/",
        building_insurance_cost_hub: "home-insurance/explained/how-much-does-buildings-insurance-cost/",
        global_blog_uk: "global_blog_uk"
    }
}), _obj);
var US_ROUTES = ALL_ROUTES.default;
var DE_ROUTES = ALL_ROUTES[DE_REGION].default; // eslint-disable-line @typescript-eslint/no-non-null-assertion
var NL_ROUTES = ALL_ROUTES[NL_REGION].default; // eslint-disable-line @typescript-eslint/no-non-null-assertion
var FR_ROUTES = ALL_ROUTES[FR_REGION].default; // eslint-disable-line @typescript-eslint/no-non-null-assertion
var GB_ROUTES = ALL_ROUTES[GB_REGION].default; // eslint-disable-line @typescript-eslint/no-non-null-assertion
var DEFAULT_EXTERNAL_ROUTES = {
    impressum: "https://lmnd-makers.s3.amazonaws.com/uploads/impressum-e5756b7e4540a4bd380be2c86e83a40e-2.pdf",
    imprint: "https://lmnd-makers.s3.amazonaws.com/uploads/impressum-e5756b7e4540a4bd380be2c86e83a40e-2.pdf",
    makers: "https://makers.lemonade.com",
    expats_de: "https://www.lemonade.com/de/blog/category/english",
    blog_en_de_liability_insurance_germany: "https://www.lemonade.com/de/blog/liability-insurance-germany/",
    expats_nl: "https://www.lemonade.com/nl/blog/category/english",
    insuropedia: "https://www.lemonade.com/insuropedia/",
    investors: "https://investor.lemonade.com/home/default.aspx",
    giveback_2021: "/giveback-2021",
    giveback_2022: "/giveback-2022",
    giveback_2023: "/giveback-2023",
    contents: "https://www.lemonade.com/onboarding/start",
    global_transparency: "https://www.lemonade.com/transparency",
    global_reviews: "https://www.lemonade.com/reviews",
    blog_en_de_deductible: "https://www.lemonade.com/de/blog/what-is-a-deductible/",
    blog_en_de_insurances_in_germany: "https://www.lemonade.com/de/blog/insurances-in-germany/",
    blog_en_de_laptop_insurance_germany: "https://www.lemonade.com/de/blog/laptop-insurance-germany/",
    blog_en_de_camera_insurance: "https://www.lemonade.com/de/blog/camera-insurance/",
    blog_en_nl_content_insurance: "https://www.lemonade.com/nl/blog/contents-insurance-netherlands/",
    blog_en_nl_liability_insurance: "https://www.lemonade.com/nl/blog/liability-insurance-netherlands/",
    global_partners_program: "https://www.lemonade.com/partners-program",
    insuropedia_nl: "https://www.lemonade.com/nl/verzekeringstermen/",
    global_api: "https://www.lemonade.com/api",
    global_blog_fr: "https://www.lemonade.com/fr/blog/",
    global_blog_uk: "https://www.lemonade.com/uk/blog/",
    global_blog_nl: "https://www.lemonade.com/nl/blog/",
    global_blog_de: "https://www.lemonade.com/de/blog/"
};
var _obj1;
var LOCALE_URL_PREFIXES = (_obj1 = {}, _define_property(_obj1, FR_FR_LOCALE, REGION_ALIASES[FR_REGION]), _define_property(_obj1, EN_FR_LOCALE, "".concat(REGION_ALIASES[FR_REGION], "/").concat(EN_LANGUAGE)), _define_property(_obj1, EN_DE_LOCALE, "".concat(REGION_ALIASES[DE_REGION], "/").concat(EN_LANGUAGE)), _define_property(_obj1, DE_DE_LOCALE, REGION_ALIASES[DE_REGION]), _define_property(_obj1, EN_NL_LOCALE, "".concat(REGION_ALIASES[NL_REGION], "/").concat(EN_LANGUAGE)), _define_property(_obj1, NL_NL_LOCALE, REGION_ALIASES[NL_REGION]), _define_property(_obj1, EN_GB_LOCALE, REGION_ALIASES[GB_REGION]), _define_property(_obj1, EN_US_LOCALE, ""), _define_property(_obj1, ES_US_LOCALE, ""), _obj1);
var _obj2;
var LOGO_TITLES = (_obj2 = {}, _define_property(_obj2, EN_US_LOCALE, "Lemonade Insurance"), _define_property(_obj2, ES_US_LOCALE, "Lemonade Insurance"), _define_property(_obj2, DE_DE_LOCALE, "Lemonade versicherung"), _define_property(_obj2, EN_DE_LOCALE, "Lemonade Insurance"), _define_property(_obj2, FR_FR_LOCALE, "Lemonade assurance"), _define_property(_obj2, EN_FR_LOCALE, "Lemonade Insurance France"), _define_property(_obj2, NL_NL_LOCALE, "Lemonade verzekering"), _define_property(_obj2, EN_NL_LOCALE, "Lemonade Insurance Netherland"), _define_property(_obj2, EN_GB_LOCALE, "Lemonade Insurance UK"), _obj2);
var _obj3;
var LOGO_ALT_TEXTS = (_obj3 = {}, _define_property(_obj3, EN_US_LOCALE, "Lemonade Insurance Company"), _define_property(_obj3, ES_US_LOCALE, "Lemonade Insurance Company"), _define_property(_obj3, DE_DE_LOCALE, "Lemonade versicherung"), _define_property(_obj3, EN_DE_LOCALE, "Lemonade Insurance Company"), _define_property(_obj3, FR_FR_LOCALE, "Lemonade assurance"), _define_property(_obj3, EN_FR_LOCALE, "Lemonade Insurance France"), _define_property(_obj3, NL_NL_LOCALE, "Lemonade verzekering"), _define_property(_obj3, EN_NL_LOCALE, "Lemonade Insurance Netherland"), _define_property(_obj3, EN_GB_LOCALE, "Lemonade Insurance UK"), _obj3);

export { ALL_ROUTES, DEFAULT_EXTERNAL_ROUTES, DE_ROUTES, FR_ROUTES, GB_ROUTES, LOCALE_URL_PREFIXES, LOGO_ALT_TEXTS, LOGO_TITLES, NL_ROUTES, US_ROUTES };
